import { REDUCERS, DRAGGABLE_WINDOWS_ACTIONS } from '../../constants.js';

const initialDragComponent = {
  reducer_type : REDUCERS.DRAGGABLE_WINDOWS_CONTROLLER,
  actionType : DRAGGABLE_WINDOWS_ACTIONS.NONE,
  closeIfOpen : false,
  dragComponent : null,
  idDragComponent : -1,
};

const dragWindowController = (state = initialDragComponent, action) => {
   state = initialDragComponent;
  switch (action.type) {
    case DRAGGABLE_WINDOWS_ACTIONS.INSERT_WINDOW:
      return { actionType: DRAGGABLE_WINDOWS_ACTIONS.INSERT_WINDOW, closeIfOpen : action.closeIfOpen, dragComponent :  action.draggableComponent };
    case DRAGGABLE_WINDOWS_ACTIONS.REMOVE_WINDOW:
      return { actionType: DRAGGABLE_WINDOWS_ACTIONS.REMOVE_WINDOW, idDragComponents : action.idComponents };
    default:
      return state;
  }
}

export default dragWindowController;


















// WEBPACK FOOTER //
// ./src/redux/reducers/reducer_draggable_windows_controller.js